@for (tarifrechnungPosition of tarifrechnungPositionen; track $index) {
    <dv-leistungsposition [leistungsPosition]="tarifrechnungPosition"></dv-leistungsposition>
}
